<template>
  <img :data-url="source" class="blur" :src="blur">
</template>

<script>
export default {
  props: ['source', 'blur']
}
</script>
